module.exports = __webpack_public_path__ + "img/academy-logo.99cc36ce.png";